import React from 'react';
import { SectionWrapper } from './Shared';
import { Moon, Apple, Dumbbell } from 'lucide-react';
export const MechanismSection = () => {
  const pillars = [{
    icon: <Moon className="w-10 h-10 text-dark-900" data-id="element-107" />,
    title: 'Sueño de Combate',
    desc: 'Para reparar tus hormonas y resetear tu sistema nervioso central.'
  }, {
    icon: <Apple className="w-10 h-10 text-dark-900" data-id="element-108" />,
    title: 'Nutrición de Poder',
    desc: 'Para darte materia prima real y eliminar la inflamación celular.'
  }, {
    icon: <Dumbbell className="w-10 h-10 text-dark-900" data-id="element-109" />,
    title: 'Movimiento de Alta Señal',
    desc: 'Para encender tu fuerza y optimizar tu testosterona natural.'
  }];
  return <SectionWrapper data-id="element-110">
      <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-111">
        <h2 className="font-oswald text-sm md:text-base text-gold-500 font-bold tracking-[0.2em] uppercase mb-4" data-id="element-112">
          El Mecanismo Único
        </h2>
        <h3 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-8" data-id="element-113">
          El Reequilibrio Biológico (S-N-M)
        </h3>
        <p className="text-xl text-zinc-300 leading-relaxed" data-id="element-114">
          Este sistema no utiliza fármacos ni requiere que vivas en el gimnasio.
          Funciona restaurando las{' '}
          <span className="text-white font-semibold" data-id="element-115">3 palancas maestras</span>{' '}
          de tu biología.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-16" data-id="element-116">
        {pillars.map((pillar, idx) => <div key={idx} className="relative group" data-id="element-117">
            <div className="absolute inset-0 bg-gold-500 rounded-2xl blur-xl opacity-0 group-hover:opacity-20 transition-opacity duration-500" data-id="element-118"></div>
            <div className="relative bg-dark-800 border border-white/10 p-8 rounded-2xl h-full flex flex-col items-center text-center z-10 hover:border-gold-500/50 transition-colors duration-300" data-id="element-119">
              <div className="w-20 h-20 bg-gold-500 rounded-full flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,165,116,0.3)]" data-id="element-120">
                {pillar.icon}
              </div>
              <h4 className="font-oswald text-2xl font-bold text-white mb-4 uppercase" data-id="element-121">
                {pillar.title}
              </h4>
              <p className="text-zinc-400" data-id="element-122">{pillar.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="text-center" data-id="element-123">
        <p className="inline-block text-lg md:text-xl text-white font-medium bg-dark-800 border border-white/10 py-4 px-8 rounded-full" data-id="element-124">
          En solo <span className="text-gold-500 font-bold" data-id="element-125">21 días</span>,
          obligamos a tu cuerpo a salir del modo supervivencia y entrar en modo
          optimización.
        </p>
      </div>
    </SectionWrapper>;
};